// 加载指示器样式
const loadingStyle = `
.loading-mask {
  position: absolute;
  z-index: 2000;
  background-color: rgba(255, 255, 255, 0.9);
  margin: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: opacity 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: inherit;
}

.loading-spinner {
  display: inline-block;
  position: relative;
  width: 50px;
  height: 50px;
}

.loading-spinner div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 40px;
  height: 40px;
  margin: 5px;
  border: 4px solid #409eff;
  border-radius: 50%;
  animation: loading-spinner 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #409eff transparent transparent transparent;
}

.loading-spinner div:nth-child(1) {
  animation-delay: -0.45s;
}

.loading-spinner div:nth-child(2) {
  animation-delay: -0.3s;
}

.loading-spinner div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes loading-spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  margin-top: 10px;
  color: #409eff;
  font-weight: bold;
  font-size: 14px;
}

.loading-wrapper {
  text-align: center;
}

.fullscreen-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 0.8);
}
`;

// 添加样式到页面
if (!document.querySelector('#v-loading-styles')) {
  const style = document.createElement('style');
  style.id = 'v-loading-styles';
  style.textContent = loadingStyle;
  document.head.appendChild(style);
}

// 创建加载指示器元素
function createLoadingElement(text = '加载中...', isFullscreen = false) {
  const loadingEl = document.createElement('div');
  loadingEl.className = isFullscreen
    ? 'loading-mask fullscreen-loading'
    : 'loading-mask';

  const spinnerEl = document.createElement('div');
  spinnerEl.className = 'loading-spinner';

  for (let i = 0; i < 4; i++) {
    const circle = document.createElement('div');
    spinnerEl.appendChild(circle);
  }

  const textEl = document.createElement('div');
  textEl.className = 'loading-text';
  textEl.textContent = text;

  const wrapperEl = document.createElement('div');
  wrapperEl.className = 'loading-wrapper';
  wrapperEl.appendChild(spinnerEl);
  wrapperEl.appendChild(textEl);

  loadingEl.appendChild(wrapperEl);
  return loadingEl;
}

// 全局加载状态管理
const loadingStates = new Map();

export default {
  install(app, options = {}) {
    const defaultOptions = {
      text: '加载中...',
      background: 'rgba(255, 255, 255, 0.9)',
      spinnerColor: '#409eff',
      ...options,
    };

    // 创建自定义指令
    app.directive('loading', {
      beforeMount(el, binding) {
        // 确保元素有相对定位
        if (getComputedStyle(el).position === 'static') {
          el.style.position = 'relative';
        }

        const loadingId = `loading-${Date.now()}-${Math.random()
          .toString(36)
          .substr(2, 9)}`;
        el.setAttribute('data-loading-id', loadingId);

        loadingStates.set(loadingId, {
          element: el,
          isLoading: false,
          loadingEl: null,
        });

        // 初始状态
        const isLoading = Boolean(binding.value);
        if (isLoading) {
          const text = el.getAttribute('loading-text') || defaultOptions.text;
          const state = loadingStates.get(loadingId);
          state.loadingEl = createLoadingElement(text);
          state.loadingEl.style.backgroundColor = defaultOptions.background;
          el.appendChild(state.loadingEl);
          state.isLoading = true;
        }
      },

      updated(el, binding) {
        const loadingId = el.getAttribute('data-loading-id');
        const state = loadingStates.get(loadingId);

        if (!state) return;

        const isLoading = Boolean(binding.value);

        if (isLoading && !state.isLoading) {
          // 显示加载
          const text = el.getAttribute('loading-text') || defaultOptions.text;
          state.loadingEl = createLoadingElement(text);
          state.loadingEl.style.backgroundColor = defaultOptions.background;
          el.appendChild(state.loadingEl);
          state.isLoading = true;
        } else if (!isLoading && state.isLoading) {
          // 隐藏加载
          if (state.loadingEl && state.loadingEl.parentNode) {
            state.loadingEl.parentNode.removeChild(state.loadingEl);
          }
          state.isLoading = false;
        }
      },

      beforeUnmount(el) {
        const loadingId = el.getAttribute('data-loading-id');
        if (loadingId) {
          const state = loadingStates.get(loadingId);
          if (state && state.loadingEl && state.loadingEl.parentNode) {
            state.loadingEl.parentNode.removeChild(state.loadingEl);
          }
          loadingStates.delete(loadingId);
        }
      },
    });

    // 添加全局方法到 app.config.globalProperties
    app.config.globalProperties.$loading = {
      // 全屏加载
      show(options = {}) {
        const text = options.text || defaultOptions.text;
        const loadingEl = createLoadingElement(text, true);
        loadingEl.style.backgroundColor =
          options.background || defaultOptions.background;
        loadingEl.id = 'global-fullscreen-loading';
        document.body.appendChild(loadingEl);

        return {
          close: () => {
            if (loadingEl.parentNode) {
              loadingEl.parentNode.removeChild(loadingEl);
            }
          },
        };
      },

      // 服务方式加载
      service(options = {}) {
        return this.show(options);
      },
    };
  },
};
